<template>
  <div class="langaugeSelector button-lang">
    <select name="size" v-model="selectedItem" @change="handleSelection">
      <option
        v-for="item in items"
        :lang="item.languagecode"
        :class="item.selected ? 'selected' : ''"
        :key="item.title"
      >
        {{ item.title }}
      </option>
    </select>
  </div>
</template>

<script>
import { setCookie } from 'Utils/common';
export default {
  name: 'language-selector',
  props: {
    items: {
      type: Array,
      required: true,
      default: [],
    },
    mobiletracking: {
      type: Object,
      required: true,
    },
    tracking: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedItem: '',
    };
  },
  mounted() {
    this.initLanguage();
  },
  methods: {
    initLanguage() {
      let element = document.getElementsByTagName('select');
      this.items.map((item, index) => {
        if (item.selected == true) {
          // element[0].value = item.title;
          this.selectedItem = item.title;
        }
      });
      element[0].addEventListener('mouseover', (event) => {
        element[0].setAttribute('size', element[0].length);
        element[0].classList.add('list-visible');
      });

      element[0].addEventListener('mouseout', (event) => {
        element[0].setAttribute('size', 1);
        element[0].classList.remove('list-visible');
      });
    },
    trackingData() {
      if (window.innerWidth < 768) {
        window.dataLayer.push(this.mobiletracking.eventProperties);
      } else {
        window.dataLayer.push(this.tracking.eventProperties);
      }
    },
    handleSelection() {
      this.items.map((item, index) => {
        if (
          item.title == this.selectedItem &&
          window.location.href != item.link
        ) {
          setCookie('languageFlag', false, this.cookielifetime);
          window.location.assign(item.link);
        }
      });
      this.trackingData();
    },
  },
};
</script>
